module.exports = __webpack_public_path__ + "img/interrogacao-preto-01.38b161b9.png";